import useBookmarks from 'containers/embed/useBookmarks'
import React, {
  createContext,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from 'react'
import { Bookmark, DEFAULT_NAV_BOOKMARK, NavigationBookmark } from 'types'


interface IBookmarkssContext {
  activeBookmark: Bookmark | NavigationBookmark
  setActiveBookmark: React.Dispatch<SetStateAction<Bookmark | NavigationBookmark>>
  reportBookmarks: Bookmark[]
  setReportBookmarks: React.Dispatch<SetStateAction<Bookmark[]>>
  navigationBookmarks: NavigationBookmark[]
  setNavigationBookmarks: React.Dispatch<SetStateAction<NavigationBookmark[]>>
}

export const BookmarksContext = createContext<IBookmarkssContext>({
  activeBookmark: DEFAULT_NAV_BOOKMARK,
  setActiveBookmark: () => {},
  reportBookmarks: [],
  setReportBookmarks: () => {},
  navigationBookmarks: [],
  setNavigationBookmarks: () => {}
})

export function BookmarksProvider({ organizationId, reportSlug, children }) {
  const [activeBookmark, setActiveBookmark] = useState<Bookmark | NavigationBookmark>(DEFAULT_NAV_BOOKMARK)
  const [reportBookmarks, setReportBookmarks] = useState<Bookmark[]>([])
  const [navigationBookmarks, setNavigationBookmarks] = useState<NavigationBookmark[]>([])

  const {getNavigationBookmarks, getBookmarks} = useBookmarks(organizationId)
  
  const getData = async () => {
    try {
      const bookmarks = await getNavigationBookmarks(reportSlug || '-maya')
      if (bookmarks)
        setNavigationBookmarks(bookmarks)

      const reportBookmarksData = await getBookmarks(reportSlug || '-maya')
      if (reportBookmarksData)
        setReportBookmarks(reportBookmarksData)
    } catch (error) {
      console.error('Error fetching navigation bookmarks:', error)
    }
  }
  
  useEffect(() => {
    (async () => {
      getData()
    })()
  }, [])

  return (
    <BookmarksContext.Provider
      value={
        {
          activeBookmark,
          setActiveBookmark,
          reportBookmarks,
          setReportBookmarks,
          navigationBookmarks,
          setNavigationBookmarks
        } as IBookmarkssContext
      }
    >
      {children}
    </BookmarksContext.Provider>
  )
}

export const useReportsCtx = () => {
  return { ...useContext(BookmarksContext) }
}
